





























import Vue from "vue";

export default Vue.extend({
  name: "PublicationArticle",
  props: ["article"],
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    resolveHref(href: string): string {
      if (/^https?:\/\//.test(href)) {
        return href;
      }
        return `/${href}`;
    }
  }
});
